const YEAR_IN_MONTHS = 12;

export function getAmortization(ltv: number) {
  if (ltv <= 50) {
    return 0;
  }

  if (ltv > 50 && ltv <= 70) {
    return 0.01;
  }

  if (ltv > 70) {
    return 0.02;
  }

  return 0;
}

export function getAmortizationAmount(ltv: number, loanAmount: number) {
  const amortization = getAmortization(ltv);

  const calculation = (amortization * loanAmount) / YEAR_IN_MONTHS;

  return Math.ceil(calculation / 100) * 100;
}

export function getInterestPayment(
  interestRate: number,
  loanAmount: number,
  isBeforeTax: boolean,
  withSecondaryApplicant: boolean,
) {
  const calculation = ((interestRate / 100) * loanAmount) / YEAR_IN_MONTHS;

  if (isBeforeTax) {
    return Math.floor(calculation);
  }

  const monthlyPaymentWithDiscount = getMonthlyPaymentWithDiscount(
    interestRate,
    loanAmount,
    withSecondaryApplicant,
  );
  return Math.floor(monthlyPaymentWithDiscount);
}

function getMonthlyPaymentWithDiscount(
  interestRate: number,
  loanAmount: number,
  withSecondaryApplicant: boolean,
) {
  const yearlyPaidAmount = (interestRate / 100) * loanAmount;
  const discountThreshold = withSecondaryApplicant ? 200000 : 100000;

  if (yearlyPaidAmount > discountThreshold) {
    const belowThreshold = discountThreshold * 0.7;
    const aboveThreshold = (yearlyPaidAmount - discountThreshold) * 0.79;

    return (belowThreshold + aboveThreshold) / 12;
  }

  return (yearlyPaidAmount * 0.7) / 12;
}
